import type { ModuleDefinition } from '@em-cms/core';

export const moduleConfig = {
  id: 'content',
  name: 'محتوا',
  description: 'مدیریت گالری، نظرات، تیم و FAQ',
  version: '0.1.0',
  is_core: false,
  requires: [],
  tables: ['cms_gallery_albums', 'cms_gallery_items', 'cms_testimonials', 'cms_team_members', 'cms_faq'],
};

export const contentModule: ModuleDefinition = {
  id: 'content',
  name: 'محتوا',
  description: 'مدیریت گالری، نظرات، تیم و FAQ',
  version: '0.1.0',
  icon: 'FileText',
  category: 'content',
  dependencies: [],
  tables: ['cms_gallery_albums', 'cms_gallery_items', 'cms_testimonials', 'cms_team_members', 'cms_faq'],
  adminRoutes: [
    {
      path: '/gallery',
      component: () => import('./admin/GalleryPage').then(m => ({ default: m.GalleryPage })),
      permission: 'content.gallery.read',
      label: 'گالری',
      icon: 'GalleryHorizontal',
    },
    {
      path: '/testimonials',
      component: () => import('./admin/TestimonialsPage').then(m => ({ default: m.TestimonialsPage })),
      permission: 'content.testimonials.read',
      label: 'نظرات',
      icon: 'MessageSquare',
    },
    {
      path: '/team',
      component: () => import('./admin/TeamPage').then(m => ({ default: m.TeamPage })),
      permission: 'content.team.read',
      label: 'تیم',
      icon: 'UsersRound',
    },
    {
      path: '/faq',
      component: () => import('./admin/FaqPage').then(m => ({ default: m.FaqPage })),
      permission: 'content.faq.read',
      label: 'FAQ',
      icon: 'HelpCircle',
    },
  ],
};
